import {createAction} from 'redux-actions';
import config from '../../config';


export function getAnnouncements() {
    return async (dispatch) => {        
        dispatch(createAction('fetchAnnouncements')());
        const result = await fetch(`${config.apiBaseUrl}/v1/news/`, {
            method: "GET",
        });
        const news = await result.json();
        return dispatch(createAction('receiveAnnouncements')(news))
    }
}